import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import LoadingSpinner from '../../components/LoadingSpinner';

const Homepage = React.lazy(() => import('../HomePage'));
// const Homepage2 = React.lazy(() => import('../HomePage2'));
// const Homepage3 = React.lazy(() => import('../HomePage3'));
const AboutPage = React.lazy(() => import('../AboutPage'));
// const ShopPage = React.lazy(() => import('../ShopPage'));
const GalleryPage = React.lazy(() => import('../GalleryPage'));
const ShopSinglePage = React.lazy(() => import('../ShopSinglePage'));
const CausePage = React.lazy(() => import('../CasePage'));
const CaseSinglePage = React.lazy(() => import('../CaseSinglePage'));
// const EventPage = React.lazy(() => import('../EventPage'));
const EventPageSingle = React.lazy(() => import('../EventPageSingle'));
const DonatePage = React.lazy(() => import('../DonatePage'));
const VolunteerPage = React.lazy(() => import('../volunteerPage'));
const BlogPage = React.lazy(() => import('../BlogPage'));
const BlogPageLeft = React.lazy(() => import('../BlogPageLeft'));
const BlogPageFullwidth = React.lazy(() => import('../BlogPageFullwidth'));
const BlogDetails = React.lazy(() => import('../BlogDetails'));
const BlogDetailsLeftSiide = React.lazy(() => import('../BlogDetailsLeftSiide'));
const BlogDetailsFull = React.lazy(() => import('../BlogDetailsFull'));
const ErrorPage = React.lazy(() => import('../ErrorPage'));
const ContactPage = React.lazy(() => import('../ContactPage'));
const LoginPage = React.lazy(() => import('../LoginPage'));
const SignUpPage = React.lazy(() => import('../SignUpPage'));
const ForgotPassword = React.lazy(() => import('../ForgotPassword'));
const CommitteePage = React.lazy(() => import('../CommitteePage'));
const MatrimonialPage = React.lazy(() => import('../MatrimonialPage'));
const MembersPage = React.lazy(() => import('../MemberPage'));
const BookingPage = React.lazy(() => import('../BookingPage'));
const HostelPage = React.lazy(() => import('../HostelPage'));
const NewsPage = React.lazy(() => import('../NewsPage'));
const FacilityPage = React.lazy(() => import('../FacilitiesPage'));
const FormsPage = React.lazy(() => import('../FormsPage'));


const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
          <Route exact path='/' element={<Homepage />} />
          <Route path='/home' element={<Homepage />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/committee' element={<CommitteePage />} />
          <Route path='/matrimonial' element={<MatrimonialPage />} />
          <Route path='/members' element={<MembersPage />} />
          {/* <Route path='/home2' element={<Homepage2 />} />
          <Route path='/home3' element={<Homepage3 />} /> */}
          <Route path='/gallery' element={<GalleryPage />} />
          <Route path='/shop-single' element={<ShopSinglePage />} />
          <Route path='/case' element={<CausePage />} />
          <Route path='/case-single' element={<CaseSinglePage />} />
          <Route path='/booking/:id?' element={<BookingPage />} />
          <Route path='/hostel' element={<HostelPage />} />
          <Route path='/facilities/:name?' element={<FacilityPage />} />
          <Route path='/facilities/forms' element={<FormsPage />} />
          <Route path='/news' element={<NewsPage />} />
          <Route path='/event' element={<NewsPage />} />
          <Route path='/event-details' element={<EventPageSingle />} />
          <Route path='/donate' element={<DonatePage />} />
          <Route path='/volunteer' element={<VolunteerPage />} />
          <Route path='/blog' element={<BlogPage />} />
          <Route path='/blog-left' element={<BlogPageLeft />} />
          <Route path='/blog-fullwidth' element={<BlogPageFullwidth />} />
          <Route path='/blog-details' element={<BlogDetails />} />
          <Route path='/blog-details-left' element={<BlogDetailsLeftSiide />} />
          <Route path='/blog-details-fullwidth' element={<BlogDetailsFull />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/login' element={<LoginPage />} />
          <Route path='/signup' element={<SignUpPage />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/*' element={<ErrorPage />} />
        </Routes>
        </Suspense>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
